import { BlogCardProps } from "../types/card.types";
import sample1 from "../assets/images/activities/sample1.png"
import sample2 from "../assets/images/activities/sample2.png"
import sample3 from "../assets/images/activities/sample3.png"
// Sample data for blog posts
export const blogPosts: BlogCardProps[] = [
    {
        id: 0,
        title: "Burger workshop",
        imageSrc: sample1,
        description: "Jak na pořádný burger? Připojte se k našemu workshopu na vytváření burgerů, který je veden zkušenými šéfkuchaři. Naučte se tajemství vytváření lahodných burgerů od začátku [...]"
    },
    {
        id: 1,
        title: "DIY / upcycling",
        imageSrc: sample2,
        description: "Připojte se k našemu workshopu na vlastnoruční výrobu a upcyklování pro kreativní a udržitelné dobrodružství! Objevte umění znovupoužívání a proměňte každodenní předměty [...]"
    },
    {
        id: 2,
        title: "Hydroponics",
        imageSrc: sample3,
        description: "Ponořte se do světa udržitelného zemědělství s naším workshopem na hydroponii. Vedeni odborníky v oboru vás tato interaktivní hodinka seznámí s inovativním světem [...]"
    },
];
